import React, { useState } from "react";
import "./HomePage.css";
import LoginForm from "../../components/account-screen/LoginForm";
import FullPagePanel from "components/reusable/FullPagePanel";
import CookieManager from "../../utilities/js/localstorage/CookieManager";
import Constants from "utilities/js/Constants";
import AccountSettingsTabs from "../../components/account-screen/AccountSettingsTabs";
import Toast from '../../components/reusable/Toast';
import { getInfoToast } from "utilities/js/ToastHelper";
import BracksetHeader from "components/reusable/BracksetHeader";
import { freezeBody, unfreezeBody } from "utilities/js/styling/domUtilities";
import NavigationTabs from "components/reusable/NavigationTabs";
import CommunityScreen from "./CommunityScreen";
import PersonalScreen from "./PersonalScreen";
import HomeScreen from "./HomeScreen";
import getURLParam from "utilities/js/ParameterRetrieval";
import { updateURLWithoutNavigation } from "utilities/js/NavigationHelper";
import NavigationPanel from "components/reusable/NavigationPanel";
import { isLoggedIn } from "utilities/js/ActionLibrary";
import VerifyEmailPrompt from "components/reusable/VerifyEmailPrompt";

const cookieManager = new CookieManager();

const HomePage = props => {
    let screenRequested = getURLParam('screen');

    const [displayAccountPanel, setDisplayAccountPanel] = useState(false);
    const [toastMessages, setToastMessages] = useState([]);
    const [currentScreen, setCurrentScreen] = useState(Constants.HOME_SCREEN_OPTIONS.includes(screenRequested) ? screenRequested : Constants.SCREEN_NAME_HOME);

    function openAccountPanel(){
        setDisplayAccountPanel(true);
        freezeBody();
    }

    function closeAccountPanel(){
        setDisplayAccountPanel(false);
        unfreezeBody();
    }

    function showInfoToast(message){
        // showInfoToast(this, message);
        let toastMessages = [...toastMessages];
        toastMessages.push(getInfoToast(message));
        setToastMessages(toastMessages);
    }

    function openHomeScreen(){
        if(currentScreen != Constants.SCREEN_NAME_HOME){
            setCurrentScreen(Constants.SCREEN_NAME_HOME);
            updateURLWithoutNavigation(Constants.SCREEN_NAME_HOME);
        }
    }

    function openCommunityScreen(){
        if(currentScreen != Constants.SCREEN_NAME_COMMUNITY){
            setCurrentScreen(Constants.SCREEN_NAME_COMMUNITY);
            updateURLWithoutNavigation(Constants.SCREEN_NAME_COMMUNITY);
        }
    }

    function openPersonalScreen(){
        if(currentScreen != Constants.SCREEN_NAME_PERSONAL){
            setCurrentScreen(Constants.SCREEN_NAME_PERSONAL);
            updateURLWithoutNavigation(Constants.SCREEN_NAME_PERSONAL);
        }
    }

    function displayAccountPanelUI(){
        if(isLoggedIn()){
            return (<AccountSettingsTabs></AccountSettingsTabs>)
        }else{
            return (<LoginForm closePanel={closeAccountPanel} showToast={showInfoToast}></LoginForm>);
        }
    }

    function getSelectedScreen(){
        if(currentScreen === Constants.SCREEN_NAME_HOME){
            return (<HomeScreen></HomeScreen>)
        }else if(currentScreen === Constants.SCREEN_NAME_COMMUNITY){
            return (<CommunityScreen></CommunityScreen>)
        }else if(currentScreen === Constants.SCREEN_NAME_PERSONAL){
            return (<PersonalScreen onSettingsClick={openAccountPanel}></PersonalScreen>)
        }
    }

    

 
    return (
    <>

        <div className="brackset-container">
            <div className="hide-desktop">
                <BracksetHeader></BracksetHeader>
            </div>
            <div className="home-nav-container">
                <NavigationPanel showRecentBrackets="true" onHomeClick={openHomeScreen} onCommunityClick={openCommunityScreen} onPersonalClick={openPersonalScreen}></NavigationPanel>
                <div className="home-nav-center-column">
                    <VerifyEmailPrompt></VerifyEmailPrompt>
                    {getSelectedScreen()}
                </div>
            </div>
            <NavigationTabs hideDesktop="true" onHomeClick={openHomeScreen} onCommunityClick={openCommunityScreen} onPersonalClick={openPersonalScreen}></NavigationTabs>
        </div>
        
        
        
      <FullPagePanel shouldDisplay={displayAccountPanel} closePanel={closeAccountPanel}> 
          {displayAccountPanelUI()}
      </FullPagePanel>
        
      <Toast 
            toastList={toastMessages}
            position="top-left"
            autoDelete="true"
            autoDeleteTime="5000"
          />
    </>
    );
  
}







// class HomePage extends React.Component {

//   constructor(props){
//     super(props);
    
//     let screenRequested = getURLParam('screen');
//     this.state = {
//       displayAccountPanel: false,
//       toastMessages: [],
//       currentScreen: Constants.HOME_SCREEN_OPTIONS.includes(screenRequested) ? screenRequested : Constants.SCREEN_NAME_HOME,
//     };

//     this.openAccountPanel = this.openAccountPanel.bind(this);
//     this.closeAccountPanel = this.closeAccountPanel.bind(this);
//     this.displayAccountPanel = this.displayAccountPanel.bind(this);

//     this.showInfoToast = this.showInfoToast.bind(this);

//     this.openHomeScreen = this.openHomeScreen.bind(this);
//     this.openCommunityScreen = this.openCommunityScreen.bind(this);
//     this.openPersonalScreen = this.openPersonalScreen.bind(this);

//   }


//     openAccountPanel(){
//         this.setState({displayAccountPanel: true});
//         freezeBody();
//     }

//     closeAccountPanel(){
//         this.setState({displayAccountPanel: false});
//         unfreezeBody();
//     }

//     showInfoToast(message){
//         showInfoToast(this, message);
//     }

//     openHomeScreen(){
//         if(this.state.currentScreen != Constants.SCREEN_NAME_HOME){
//             this.setState({currentScreen: Constants.SCREEN_NAME_HOME});
//             updateURLWithoutNavigation(Constants.SCREEN_NAME_HOME);
//         }
//     }

//     openCommunityScreen(){
//         if(this.state.currentScreen != Constants.SCREEN_NAME_COMMUNITY){
//             this.setState({currentScreen: Constants.SCREEN_NAME_COMMUNITY});
//             updateURLWithoutNavigation(Constants.SCREEN_NAME_COMMUNITY);
//         }
//     }

//     openPersonalScreen(){
//         if(this.state.currentScreen != Constants.SCREEN_NAME_PERSONAL){
//             this.setState({currentScreen: Constants.SCREEN_NAME_PERSONAL});
//             updateURLWithoutNavigation(Constants.SCREEN_NAME_PERSONAL);
//         }
//     }

//     displayAccountPanel(){
//         if(isLoggedIn()){
//             return (<AccountSettingsTabs></AccountSettingsTabs>)
//         }else{
//             return (<LoginForm closePanel={this.closeAccountPanel} showToast={this.showInfoToast}></LoginForm>);
//         }
//     }

//     get selectedScreen(){
//         if(this.state.currentScreen === Constants.SCREEN_NAME_HOME){
//             return (<HomeScreen></HomeScreen>)
//         }else if(this.state.currentScreen === Constants.SCREEN_NAME_COMMUNITY){
//             return (<CommunityScreen></CommunityScreen>)
//         }else if(this.state.currentScreen === Constants.SCREEN_NAME_PERSONAL){
//             return (<PersonalScreen onSettingsClick={this.openAccountPanel}></PersonalScreen>)
//         }
//     }

    

//   render(){
 
//     return (
//     <>

//         <div className="brackset-container">
//             <div  className="hide-desktop">
//                 <BracksetHeader></BracksetHeader>
//             </div>
//             <div className="home-nav-container">
//                 <NavigationPanel showRecentBrackets="true" onHomeClick={this.openHomeScreen} onCommunityClick={this.openCommunityScreen} onPersonalClick={this.openPersonalScreen}></NavigationPanel>
//                 <div className="home-nav-center-column">
//                     {this.selectedScreen}
//                 </div>
//             </div>
//             <NavigationTabs hideDesktop="true" onHomeClick={this.openHomeScreen} onCommunityClick={this.openCommunityScreen} onPersonalClick={this.openPersonalScreen}></NavigationTabs>
//         </div>
        
        
        
//       <FullPagePanel shouldDisplay={this.state.displayAccountPanel} closePanel={this.closeAccountPanel}> 
//           {this.displayAccountPanel()}
//       </FullPagePanel>
        
//       <Toast 
//             toastList={this.state.toastMessages}
//             position="top-left"
//             autoDelete="true"
//             autoDeleteTime="5000"
//           />
//     </>
//     );
//   }
// }

export default HomePage;
